export const decimalCalc = (input: number, decimalPoint = 10): number => {
	return Math.round(input * decimalPoint) / decimalPoint;
};
